import { Rating } from "@smastrom/react-rating";
import { useState, useRef, useEffect } from "react";
import { sendReview, getReview } from "../../../services/AthleteService";
import { useAxiosInstance } from "../../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { toast } from "react-toastify";
import "@smastrom/react-rating/style.css";

export function AthleteReview() {
  const [rating, setRating] = useState(1);
  const [loading, setLoading] = useState(false);
  const [reviewText, setReviewText] = useState("");
  const titleRef = useRef(null);
  const reviewRef = useRef(null);
  const formRef = useRef(null);
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();

  useEffect(() => {
    const getReviewUseEffect = async () => {
      try {
        setLoading(true);
        const response = await getReview(apiInstance, authUser?.user?.id);
        if (response.status === 200) {
          titleRef.current.value = response.data.reviewTitle || "";
          setReviewText(response.data.reviewText || "");
          setRating(response.data.numberOfStars || 1);
        }
      } catch (err) {
        toast.error(err.response);
      } finally {
        setLoading(false);
      }
    };
    getReviewUseEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (reviewText.length > 209) {
      toast.error("The review cannot exceed 209 characters.");
      return;
    }

    try {
      setLoading(true);
      const data = {
        reviewTitle: titleRef.current.value,
        reviewText: reviewText,
        numberOfStars: rating,
      };
      await sendReview(apiInstance, authUser?.user?.id, data);
      toast.success("Review sent successfully.");
    } catch (err) {
      toast.error(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="flex justify-end">
        <Rating style={{ maxWidth: 180 }} value={rating} onChange={setRating} />
      </div>
      <form
        ref={formRef}
        className="flex flex-col space-y-3 mt-5"
        onSubmit={handleSubmit}
      >
        <input
          ref={titleRef}
          type="text"
          className="border border-gray-300 p-2 w-full"
          placeholder="Title"
          required
          maxLength={150}
        />
        <textarea
          ref={reviewRef}
          className="border border-gray-300 p-2 w-full"
          rows={5}
          placeholder="Review"
          required
          maxLength={209}
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
          style={{
            maxHeight: "400px",
            overflow: "auto",
            resize: "vertical",
          }}
        ></textarea>
        <div className="flex justify-between">
          <span className="text-gray-500">
            {209 - reviewText.length} characters remaining
          </span>
          <button
            type="submit"
            className={`bg-red-500 text-white uppercase rounded-md px-6 py-2 text-center hover:bg-red-800 cursor-pointer mt-2 text-sm ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit Review"}
          </button>
        </div>
      </form>
    </div>
  );
}
